import { render, staticRenderFns } from "./ServiceChips.vue?vue&type=template&id=427b1818&scoped=true"
import script from "./ServiceChips.vue?vue&type=script&lang=js"
export * from "./ServiceChips.vue?vue&type=script&lang=js"
import style0 from "./ServiceChips.vue?vue&type=style&index=0&id=427b1818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b1818",
  null
  
)

export default component.exports